import { Button, Stack } from "@mui/material";
import React, { useState } from "react";

import { REVIEW_NONVERBAL_DIALOGUE } from "../../ApiEndpoints";
import { postWithFirebaseAuth } from "../../utils/firebaseApiClient";
import NonverbalBadge from "./NonverbalBadge.js";
import { isSuggested, nonverbalOf } from "./nonverbal.js";

// Shown by a line's "Use original text" toggle when non-verbal detection set
// it, took a tag out of the line, or suggests keeping the original audio. `onReviewed`
// gets the fields the decision changed (nonverbal, keepOriginalText, ...).
const NonverbalLineNotice = ({ dialogue, projectId, onReviewed }) => {
    const [busy, setBusy] = useState(false);
    const nonverbal = nonverbalOf(dialogue);
    if (!nonverbal || nonverbal.state === "rejected") {
        return null;
    }

    const review = async (decision) => {
        setBusy(true);
        try {
            const response = await postWithFirebaseAuth(REVIEW_NONVERBAL_DIALOGUE, {
                projectId,
                dbid: dialogue.dbid,
                decision,
            });
            const { status, ...changes } = response.data || {};
            onReviewed?.(changes);
        } catch (err) {
            console.log(err);
            alert("Couldn't save your decision on this line");
        } finally {
            setBusy(false);
        }
    };

    return (
        <Stack direction="row" spacing={1} alignItems="center" marginTop={0.5}>
            <NonverbalBadge item={dialogue} />
            {isSuggested(dialogue) && nonverbal.action === "keepOriginalText" ? (
                <>
                    <Button size="small" disabled={busy} onClick={() => review("accept")}>
                        Keep original
                    </Button>
                    <Button
                        size="small"
                        color="error"
                        disabled={busy}
                        onClick={() => review("reject")}
                    >
                        Dismiss
                    </Button>
                </>
            ) : null}
            {!isSuggested(dialogue) && nonverbal.action === "tagsRemoved" && !nonverbal.reviewed ? (
                <Button size="small" color="error" disabled={busy} onClick={() => review("reject")}>
                    Put the tag back
                </Button>
            ) : null}
        </Stack>
    );
};

export default NonverbalLineNotice;
